import React from 'react';

import {
  ClientIcon,
  CompanyIcon,
  IndustryIcon,
  LocationIcon,
  PassionIcon,
  PeopleIcon,
  SkillIcon,
} from 'app/components/DetailsPages/shared/CommonGround/Icons';
import {
  AddBoldIcon,
  ChatCircleIcon,
  FeedbackIcon,
  LinkedInIcon,
  PersonIcon,
  PromptIcon,
  Sparkle,
} from 'app/components/shared/icons';
import AddImage from 'app/components/shared/icons/add-image';
import Calendar from 'app/components/shared/icons/calendar';
import EditPencilIcon from 'app/components/shared/icons/edit-pencil';
import LightningIcon from 'app/components/shared/icons/lightning-icon';

export const WAYFINDING_DRAWERS = {
  PROFILE_IMAGE: 'profile-image',
  LANGUAGES: 'languages',
  EXPERIENCE: 'experience',
  ROLE: 'role',
  PRIOR_COMPANIES: 'prior-companies',
  PRIOR_INDUSTRIES: 'prior-industries',
  PRIOR_CLIENTS: 'prior-clients',
  SKILLS: 'skills',
  PASSIONS: 'passions',
  BIO: 'bio',
  OUTSIDE_OF_WORK: 'outside-of-work',
  LINKEDIN: 'linkedin',
  DREAM_PROJECT: 'dream-project',
  LOCATIONS: 'people_countries',
};

export const wayfindingDrawerToCompletionField = new Map<
  (typeof WAYFINDING_DRAWERS)[keyof typeof WAYFINDING_DRAWERS],
  string
>([
  [WAYFINDING_DRAWERS.PROFILE_IMAGE, 'profile_image'],
  [WAYFINDING_DRAWERS.LANGUAGES, 'languages'],
  [WAYFINDING_DRAWERS.EXPERIENCE, 'work_experience'],
  [WAYFINDING_DRAWERS.ROLE, 'role_description'],
  [WAYFINDING_DRAWERS.PRIOR_COMPANIES, 'companies_worked_for'],
  [WAYFINDING_DRAWERS.PRIOR_INDUSTRIES, 'industries'],
  [WAYFINDING_DRAWERS.PRIOR_CLIENTS, 'companies_worked_with'],
  [WAYFINDING_DRAWERS.SKILLS, 'skills_self_assessed'],
  [WAYFINDING_DRAWERS.PASSIONS, 'passions'],
  [WAYFINDING_DRAWERS.BIO, 'bio'],
  [WAYFINDING_DRAWERS.OUTSIDE_OF_WORK, 'outside_work'],
  [WAYFINDING_DRAWERS.LINKEDIN, 'linkedin'],
  [WAYFINDING_DRAWERS.DREAM_PROJECT, 'dream_project'],
  [WAYFINDING_DRAWERS.LOCATIONS, 'people_countries'],
]);

export const wayfindindCompletionFieldToDrawer = new Map<
  string,
  (typeof WAYFINDING_DRAWERS)[keyof typeof WAYFINDING_DRAWERS]
>([
  ['profile_image', WAYFINDING_DRAWERS.PROFILE_IMAGE],
  ['languages', WAYFINDING_DRAWERS.LANGUAGES],
  ['work_experience', WAYFINDING_DRAWERS.EXPERIENCE],
  ['role_description', WAYFINDING_DRAWERS.ROLE],
  ['companies_worked_for', WAYFINDING_DRAWERS.PRIOR_COMPANIES],
  ['industries', WAYFINDING_DRAWERS.PRIOR_INDUSTRIES],
  ['companies_worked_with', WAYFINDING_DRAWERS.PRIOR_CLIENTS],
  ['skills_self_assessed', WAYFINDING_DRAWERS.SKILLS],
  ['passions', WAYFINDING_DRAWERS.PASSIONS],
  ['bio', WAYFINDING_DRAWERS.BIO],
  ['outside_work', WAYFINDING_DRAWERS.OUTSIDE_OF_WORK],
  ['linkedin', WAYFINDING_DRAWERS.LINKEDIN],
  ['dream_project', WAYFINDING_DRAWERS.DREAM_PROJECT],
  ['people_countries', WAYFINDING_DRAWERS.LOCATIONS],
]);

export const wayfindingDrawerToTitle = new Map<
  (typeof WAYFINDING_DRAWERS)[keyof typeof WAYFINDING_DRAWERS],
  string
>([
  [WAYFINDING_DRAWERS.PROFILE_IMAGE, 'PROFILE PHOTO'],
  [WAYFINDING_DRAWERS.LANGUAGES, 'LANGUAGES'],
  [WAYFINDING_DRAWERS.EXPERIENCE, 'YEARS OF EXPERIENCE'],
  [WAYFINDING_DRAWERS.ROLE, 'YOUR ROLE'],
  [WAYFINDING_DRAWERS.PRIOR_COMPANIES, 'PRIOR COMPANIES'],
  [WAYFINDING_DRAWERS.PRIOR_INDUSTRIES, 'PRIOR INDUSTRIES'],
  [WAYFINDING_DRAWERS.PRIOR_CLIENTS, 'PRIOR CLIENTS'],
  [WAYFINDING_DRAWERS.SKILLS, 'SKILLS'],
  [WAYFINDING_DRAWERS.PASSIONS, 'PASSIONS'],
  [WAYFINDING_DRAWERS.BIO, 'BIO'],
  [WAYFINDING_DRAWERS.OUTSIDE_OF_WORK, 'OUTSIDE OF WORK'],
  [WAYFINDING_DRAWERS.LINKEDIN, 'LINKEDIN'],
  [WAYFINDING_DRAWERS.DREAM_PROJECT, 'DREAM PROJECT'],
  [WAYFINDING_DRAWERS.LOCATIONS, 'LOCATIONS'],
]);

export const wayfindingDrawerToCTAIcon = new Map<
  (typeof WAYFINDING_DRAWERS)[keyof typeof WAYFINDING_DRAWERS],
  React.ReactNode
>([
  [
    WAYFINDING_DRAWERS.PROFILE_IMAGE,
    <EditPencilIcon width={16} height={16} fill="rgba(23, 28, 51, 0.5)" />,
  ],
  [WAYFINDING_DRAWERS.LANGUAGES, <AddBoldIcon fill="rgba(23, 28, 51, 0.5)" />],
  [
    WAYFINDING_DRAWERS.EXPERIENCE,
    <EditPencilIcon width={16} height={16} fill="rgba(23, 28, 51, 0.5)" />,
  ],
  [WAYFINDING_DRAWERS.ROLE, <EditPencilIcon width={16} height={16} fill="rgba(23, 28, 51, 0.5)" />],
  [WAYFINDING_DRAWERS.PRIOR_COMPANIES, <AddBoldIcon fill="rgba(23, 28, 51, 0.5)" />],
  [WAYFINDING_DRAWERS.PRIOR_INDUSTRIES, <AddBoldIcon fill="rgba(23, 28, 51, 0.5)" />],
  [WAYFINDING_DRAWERS.PRIOR_CLIENTS, <AddBoldIcon fill="rgba(23, 28, 51, 0.5)" />],
  [WAYFINDING_DRAWERS.SKILLS, <AddBoldIcon fill="rgba(23, 28, 51, 0.5)" />],
  [WAYFINDING_DRAWERS.PASSIONS, <AddBoldIcon fill="rgba(23, 28, 51, 0.5)" />],
  [WAYFINDING_DRAWERS.BIO, <EditPencilIcon width={16} height={16} fill="rgba(23, 28, 51, 0.5)" />],
  [
    WAYFINDING_DRAWERS.OUTSIDE_OF_WORK,
    <EditPencilIcon width={16} height={16} fill="rgba(23, 28, 51, 0.5)" />,
  ],
  [
    WAYFINDING_DRAWERS.LINKEDIN,
    <EditPencilIcon width={16} height={16} fill="rgba(23, 28, 51, 0.5)" />,
  ],
  [
    WAYFINDING_DRAWERS.DREAM_PROJECT,
    <EditPencilIcon width={16} height={16} fill="rgba(23, 28, 51, 0.5)" />,
  ],
  [
    WAYFINDING_DRAWERS.LOCATIONS,
    <EditPencilIcon width={16} height={16} fill="rgba(23, 28, 51, 0.5)" />,
  ],
]);

export type WayfindingActiveProfileMenuDrawersType =
  (typeof WAYFINDING_DRAWERS)[keyof typeof WAYFINDING_DRAWERS];

export const wayfindingDrawerToIcon = new Map<
  (typeof WAYFINDING_DRAWERS)[keyof typeof WAYFINDING_DRAWERS],
  React.ReactNode
>([
  [
    WAYFINDING_DRAWERS.PROFILE_IMAGE,
    <AddImage width={24} height={24} fill="var(--color-data-people-foreground)" />,
  ],
  [
    WAYFINDING_DRAWERS.LANGUAGES,
    <PeopleIcon width={24} height={24} fill="var(--color-data-people-foreground)" />,
  ],
  [WAYFINDING_DRAWERS.EXPERIENCE, <Calendar width={24} height={24} fill="#5478A1" />],
  [
    WAYFINDING_DRAWERS.ROLE,
    <LightningIcon width={24} height={24} fill="var(--color-data-project-foreground)" />,
  ],
  [
    WAYFINDING_DRAWERS.PRIOR_COMPANIES,
    <CompanyIcon width={24} height={24} fill="var(--color-data-company-foreground)" />,
  ],
  [
    WAYFINDING_DRAWERS.PRIOR_INDUSTRIES,
    <IndustryIcon width={24} height={24} fill="var(--color-data-industry-foreground)" />,
  ],
  [
    WAYFINDING_DRAWERS.PRIOR_CLIENTS,
    <ClientIcon width={24} height={24} fill="var(--color-data-client-foreground)" />,
  ],
  [
    WAYFINDING_DRAWERS.SKILLS,
    <SkillIcon width={24} height={24} fill="var(--color-data-skill-foreground)" />,
  ],
  [
    WAYFINDING_DRAWERS.PASSIONS,
    <PassionIcon width={24} height={24} fill="var(--color-data-passion-foreground)" />,
  ],
  [
    WAYFINDING_DRAWERS.BIO,
    <FeedbackIcon width={24} height={24} fill="var(--color-data-people-foreground)" />,
  ],
  [
    WAYFINDING_DRAWERS.OUTSIDE_OF_WORK,
    <PromptIcon width={24} height={24} fill="var(--color-data-passion-foreground)" />,
  ],
  [
    WAYFINDING_DRAWERS.LINKEDIN,
    <LinkedInIcon width={24} height={24} fill="var(--color-primary)" />,
  ],
  [
    WAYFINDING_DRAWERS.DREAM_PROJECT,
    <Sparkle width={24} height={24} fill="var(--color-data-project-foreground)" />,
  ],
  [
    WAYFINDING_DRAWERS.LOCATIONS,
    <LocationIcon width={24} height={24} fill="var(--color-data-people-foreground)" />,
  ],
]);
